export const EXPRESSION = {
  START: '{{',
  END: '}}',
};
export const LIST_ITEM_EXP = '$listItem';
export const LIST_ITEM_INDEX_EXP = '$i';
export const SLOT_PROPS_EXP = '$slot';
export const GLOBAL_UTIL_METHOD_ID = '$utils';
export const GLOBAL_MODULE_ID = '$module';
export const MODULE_ID_EXP = '{{$moduleId}}';

export const ExpressionKeywords = [
  LIST_ITEM_EXP,
  LIST_ITEM_INDEX_EXP,
  SLOT_PROPS_EXP,
  GLOBAL_UTIL_METHOD_ID,
  GLOBAL_MODULE_ID,
];

export const AnyTypePlaceholder = '__any__';
